<template>
  <section>
    <p class="text-center pt-3"><q><em>{{ quote }}</em></q></p>
    <div class="d-flex justify-content-center mt-2">
      <h1 class="w-95 p-2 pl-4 bg-color-grey border rounded text-white font-size-xxl">My Profile</h1>
    </div>
    <div v-if="successUpdate" class="d-flex justify-content-center">
      <div class="alert alert-success text-center w-95" role="alert">
        <span class="font-weight-bold">Your profile account has been updated successfully !</span>
        <button @click="hideShowAlertMessage" type="button" class="float-right btn btn-outline-secondary btn-sm">X</button>
      </div>
    </div>
    <form @submit.prevent="onSubmit" class="ml-4 ml-md-5 w-90">
      <div class="d-md-flex">
        <div class="d-flex w-100">
          <div class="mr-2">
            <label for="name" class="font-weight-bold text-color-grey"><span>Name :</span></label>
          </div>
          <div class="w-70">
            <input @blur="$v.userDataForm.name.$touch()" v-model="userDataForm.name" type="text" name="name" id="name"
                   class="form-control customizedInput" placeholder="Enter your name">
            <hr class="mt-0 mb-0 bg-color-grey">
          </div>
        </div>
        <div v-if="$v.userDataForm.name.$error">
          <span v-if="!$v.userDataForm.name.minLength" class="text-danger">
            * Your name must be at least {{ $v.userDataForm.name.$params.minLength.min }} characters long !
          </span>
          <span v-if="!$v.userDataForm.name.required" class="text-danger">* Name can not be empty !</span>
        </div>
        <div class="d-flex w-100">
          <div class="mr-2">
            <label for="surname" class="font-weight-bold text-color-grey"><span>Surname :</span></label>
          </div>
          <div class="w-70">
            <input @blur="$v.userDataForm.surname.$touch()" v-model="userDataForm.surname" type="text" name="surname"
                   id="surname" class="form-control customizedInput" placeholder="Enter your surname">
            <hr class="mt-0 mb-0 bg-color-grey">
          </div>
        </div>
        <div v-if="$v.userDataForm.surname.$error">
          <span v-if="!$v.userDataForm.surname.minLength" class="text-danger">
            * Your surname must be at least {{ $v.userDataForm.surname.$params.minLength.min }} characters long !
          </span>
          <span v-if="!$v.userDataForm.surname.required" class="text-danger">* Surname can not be empty !</span>
        </div>
      </div>
      <div class="d-md-flex">
        <div class="d-flex w-100">
          <div class="mr-2">
            <label for="phonenumber" class="font-weight-bold text-color-grey"><span>Phone :</span></label>
          </div>
          <div class="w-70">
            <input @blur="$v.userDataForm.phonenumber.$touch()" v-model="userDataForm.phonenumber" type="number"
                   name="phonenumber" id="phonenumber" class="form-control customizedInput"
                   placeholder="Enter your phone number">
            <hr class="mt-0 mb-0 bg-color-grey">
          </div>
        </div>
        <div v-if="$v.userDataForm.phonenumber.$error">
          <span v-if="!$v.userDataForm.phonenumber.numeric" class="text-danger">
            You have to enter digit number !
          </span>
          <br v-if="!$v.userDataForm.phonenumber.numeric && !$v.userDataForm.phonenumber.minLength">
          <span v-if="!$v.userDataForm.phonenumber.minLength" class="text-danger">
            Your phone number should contain {{ $v.userDataForm.phonenumber.$params.minLength.min }} digits  !
          </span>
        </div>
        <div class="d-flex w-100">
          <div class="mr-2">
            <label for="address" class="font-weight-bold text-color-grey"><span>Address :</span></label>
          </div>
          <div class="w-70">
            <input @blur="$v.userDataForm.address.$touch()" v-model="userDataForm.address" type="text" name="address"
                   id="address" class="form-control customizedInput" placeholder="Enter your home address">
            <hr class="mt-0 mb-0 bg-color-grey">
          </div>
        </div>
        <div v-if="$v.userDataForm.address.$error">
          <span v-if="!$v.userDataForm.address.minLength" class="text-danger">
            Your home address has to be {{ $v.userDataForm.address.$params.minLength.min }} characters long  !
          </span>
        </div>
      </div>
      <div class="d-md-flex">
        <div class="d-flex w-100">
          <div class="mr-2">
            <label for="email" class="font-weight-bold text-color-grey"><span>Email :</span></label>
          </div>
          <div class="w-70">
            <input @blur="$v.userDataForm.email.$touch()" v-model="userDataForm.email" type="email" name="email"
                   id="email" class="form-control customizedInput" placeholder="Enter your email address">
            <hr class="mt-0 mb-0 bg-color-grey">
          </div>
        </div>
        <div v-if="$v.userDataForm.email.$error">
          <span v-if="!$v.userDataForm.email.email" class="text-danger">
            * Please provide a valid email address !
          </span>
          <span v-if="!$v.userDataForm.email.required" class="text-danger">
            * Email address can not be empty !
          </span>
        </div>
      </div>
      <div class="text-center mb-5">
        <button type="submit" class="mt-5 btn bg-color-grey text-white" :disabled="$v.userDataForm.$invalid">
          Save
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { FORM_UPDATE_PROFILE } from '../validations/formUpdateProfile'
export default {
  name: 'UpdateProfile',
  data () {
    return {
      quote: this.$store.state.quotes[Math.floor(Math.random() * this.$store.state.quotes.length)],
      userDataForm: {
        name: null,
        surname: null,
        phonenumber: null,
        address: null,
        email: null,
        password: null
      },
      successUpdate: false
    }
  },
  // fetch user object by his email address before being able to update his profile
  created () {
    this.$store.dispatch('fetchUserByEmail')
      .then(() => {
        this.getUserDataFromStore()
        console.log('User fetched successfully !')
      })
      .catch(() => console.log('Failed to fetch user !'))
  },
  methods: {
    // binding user object to the form
    getUserDataFromStore () {
      if (!this.$store.getters.user) return false
      else {
        const user = this.$store.getters.user
        this.userDataForm.name = user.name
        this.userDataForm.surname = user.surname
        this.userDataForm.phonenumber = user.phonenumber
        this.userDataForm.address = user.address
        this.userDataForm.email = user.email
        this.userDataForm.password = user.password
        console.log('password user : ' + user.password)
      }
    },
    // show success message when user profile has been updated successfully
    hideShowAlertMessage () {
      this.successUpdate = !this.successUpdate
    },
    // Post user object after successfully submission
    onSubmit () {
      const formData = {
        name: this.userDataForm.name,
        surname: this.userDataForm.surname,
        phonenumber: this.userDataForm.phonenumber,
        address: this.userDataForm.address,
        email: this.userDataForm.email,
        password: this.userDataForm.password
      }
      console.log(formData)
      this.$store.dispatch('updateUserProfile', formData)
        .then(isSuccess => {
          isSuccess === true ? this.successUpdate = true : this.successUpdate = false
          console.log('response axios put user profile = ' + isSuccess)
        })
    }
  },
  // Load validations requirements of the update profile form
  validations: FORM_UPDATE_PROFILE
}
</script>

<style scoped>
  label{
    padding: 15px 0 0 0;
  }
  .customizedInput{
    border: none;
    padding: 15px 0 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/UpdateProfile.vue